import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import ProviderColumn from '../../../../../features/components/ListItemsTable/Columns/ProviderColumn'
import Chip from '../../../../../components/Chip'

import { ReactComponent as ArrowIcon } from '../../../../../assets/icons/right-arrow.svg'

import { formatNumber } from '../../../../../helpers/numbers'

import { selectedAdAccountsSelector } from '../../../../../modules/selectors/adAccounts'

import { PROVIDER_TO_PLATFORMS } from '../../../../../constants/selectLists/platformList'
import { CHIP_COLORS } from '../../../../../constants/other'

import useStyles from '../styles'

const CampaignItem = ({ campaign }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const { name, provider, budget, new_budget: newBudget } = campaign

  const selectedAdAccounts = useSelector(selectedAdAccountsSelector)

  const currencySymbol = selectedAdAccounts[PROVIDER_TO_PLATFORMS[provider]]?.currency_symbol

  const formattedBudget = budget && formatNumber(budget)
  const formattedNewBudget = newBudget && formatNumber(newBudget)

  return (
    <div className={classes.campaignItem}>
      <ProviderColumn provider={provider} className={classes.providerColumn} />
      <div>
        <p className={classes.campaignName}>{name}</p>
        <div className={classes.updateSuggestionRow}>
          <p>{t('Update budget')}</p>
          <div className={classes.chipsWrapper}>
            <Chip text={`${currencySymbol}${formattedBudget}`} showCircle={false} />
            <ArrowIcon className={classes.arrowIcon} />
            <Chip text={`${currencySymbol}${formattedNewBudget}`} color={CHIP_COLORS.success} showCircle={false} />
          </div>
        </div>
      </div>
    </div>
  )
}

CampaignItem.propTypes = {
  campaign: PropTypes.object.isRequired
}

export default CampaignItem
